import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cd-calculator',
  component: () => import('../../routes/CdCalculator.svelte'),
  card: {
    id: 'cd-calculator',
    title: 'CD Calculator',
    description: 'Calculate CD returns with different compounding frequencies and compare to savings accounts.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/cd-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'CD Calculator – Certificate of Deposit Returns & APY Calculator',
    description: 'Free CD calculator to calculate certificate of deposit returns, APY, and compare CD rates. Supports multiple compounding frequencies and early withdrawal penalties.',
  },
};

export default meta;
